import React from 'react'
import { Image } from '@/atoms/Image'
import { AsH3, ParagraphSM, TitleLG } from '@/atoms/Text'
import { AppDownloadLinks } from '@/organisms/AppDownloadLinks'
import { useTranslate } from '@/utils/translate/translate-client'

export const AppPromo: React.FC = () => {
  const { t } = useTranslate('app-promo')

  return (
    <section role="complementary" className="rounded-lg border border-core-gray-200 bg-core-gray-100" id="download">
      <div className="relative flex flex-col items-center justify-between gap-6 p-8">
        <div className="h-full w-full">
          <div className="md:hidden lg:block">
            <Image
              className="md:hidden lg:block"
              src="w_354,ar_4:3/v1706733845/angel-studios/landing/app-promo-3.webp"
              width={354}
              height={240}
              style={{ width: '100%', height: 'auto' }}
              alt={t('angelOnDevices', 'Angel on multiple devices')}
            />
          </div>
          <div className="hidden md:block lg:hidden">
            <Image
              className="hidden md:block lg:hidden"
              src="w_560,ar_4:3/v1706733845/angel-studios/landing/app-promo-3.webp"
              width={560}
              height={379}
              style={{ width: '100%', height: 'auto' }}
              alt={t('angelOnDevices', 'Angel on multiple devices')}
            />
          </div>
        </div>
        <div className="h-full w-full">
          <div className="mb-6">
            <TitleLG weight="bold" as={AsH3} className="mb-4 text-center lg:text-left">
              {t('watchAnytimeAnywhere', 'Watch Anytime. Anywhere.')}
            </TitleLG>
            <ParagraphSM color="core-gray-700" className="text-center lg:text-left">
              {t(
                'theAngelAppDescriptionv2',
                'The Angel app is the home of record-shattering stories that amplify light. In the Angel app users can watch full episodes, cast to their television, Pay it Forward to fund future seasons of shows they love and buy official merchandise. Download the app below for free.',
              )}
            </ParagraphSM>
          </div>
          <div data-testid={t('angelAppDownloads', 'Angel App Downloads')} className="mt-6 flex items-center">
            <AppDownloadLinks />
          </div>
        </div>
      </div>
    </section>
  )
}
